import { createSlice } from '@reduxjs/toolkit';
import UserFactory from '../../utils/user-factory';

const initialState = {
    users: []
};

export const userSlice = createSlice({

    name: "user",
    initialState,

    reducers: {
        setUsers: (state, action) => {
            state.users = action.payload;
        },
        handleUsersList: (state, action) => {
            const { oldUser, newUser } = action.payload;

            if (oldUser) {
                const oldUserIndex = state.users.findIndex(user => user.userId === oldUser.userId);
                if (oldUserIndex !== -1) {
                    state.users.splice(oldUserIndex, 1);
                }
            }

            if (newUser) {
                const existingUser = state.users.find(user => user.userId === newUser.userId);
                if (!existingUser) {
                    const userFactory = new UserFactory();
                    const enrichedUser = {
                        ...newUser,
                        color: userFactory.getRandomColor(),
                        shortName: userFactory.getInitials(newUser.userName)
                    };
                    state.users.push(enrichedUser);
                }
            }
        },
        clearUsers: (state, action) => {
            state.users = [];
        }
    },

});

export const findUser = (state, userId) => {
    return state.user.users.find(user => user.userId === userId);
}

export const { setUsers, handleUsersList, clearUsers } = userSlice.actions;

export const user = (state) => state.user;

export default userSlice.reducer;